export const defaultColors = [
  "#262A31",
  "#109FEE",
  "#9254DE",
  "#597EF7",
  "#EB2F96",
  "#F5222D",
  "#FA8C16",
  "#FADB14",
  "#52C41A",
];
